import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  h1 {
    font-size: 1.3rem;
  }

  h2 {
    margin-top: 16px;
    font-size: 1rem;
    color: #878787;
    font-style: italic;
  }
`;

export const DatePickerContainer = styled.div`
  margin-top: 30px;
`;

export const DefaultCreationFormGroup = styled.div`
  margin: 24px 0;

  label {
    min-width: 145px;
    margin-bottom: 10px;
    font-size: var(--font-small);
    color: var(--primary-color);
    font-weight: 700;
  }

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

  .currency-input {
    border-radius: 5px;
    border: solid 1px var(--default-dark-gray);
    outline: none;
    font-size: var(--font-small);
    width: 100%;
    height: 44px;
    padding: 0 10px;
    color: var(--default-gray);
  }
`;
